const helper = {
  /**
   * 将给定的查询参数拼接到指定的URL中
   * @param {string} url - 原始URL地址
   * @param {object} query - 包含查询参数的对象
   * @returns {string} - 拼接了查询参数的URL地址
   */
  queryString (url, query) {
    const str = []
    for (const key in query) {
      str.push(key + '=' + query[key])
    }
    const paramStr = str.join('&')
    return paramStr ? `${url}?${paramStr}` : url
  },

  /**
   * 从地址栏中获取指定名称的查询参数值
   * @param {string} name - 查询参数的名称
   * @returns {string} - 查询参数的值，如果不存在则返回空字符串
   */
  getHashQueryString (name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
    const hash = window.location.href
    const search = hash.split('?')
    const r = search[1] && search[1].match(reg)
    if (r != null) return r[2]
    return ''
  },

  /**
   * 从URL中删除指定名称的查询参数
   * @param {string} url - 原始URL地址
   * @param {string} name - 要删除的查询参数的名称
   * @returns {string} - 删除了指定查询参数后的URL地址
   */
  deleteQueryString (url, name) {
    let str = ''
    if (url.indexOf('?') !== -1) {
      str = url.substr(url.indexOf('?') + 1)
    } else {
      return url
    }
    let arr = []
    let returnurl = ''
    if (str.indexOf('&') !== -1) {
      arr = str.split('&')
      for (const i in arr) {
        if (arr[i].split('=')[0] !== name) {
          returnurl =
            returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&'
        }
      }
      return (
        url.substr(0, url.indexOf('?')) +
        '?' +
        returnurl.substr(0, returnurl.length - 1)
      )
    } else {
      arr = str.split('=')
      if (arr[0] === name) {
        return url.substr(0, url.indexOf('?'))
      } else {
        return url
      }
    }
  }
}
export default helper
